import $ from 'jquery'

export default class IADropdown {

    /**
     * Creates an instance of IADropdown.
     * @param {HTMLElement|String} toggler
     * @param {String} [target]
     * @memberof IADropdown
     */
    constructor(toggler, target) {
        toggler.addEventListener('click', (e) => {
            if (target === undefined || target === null) {
                // check if toggler has a data-target or data-toggle attribute
                target = toggler.getAttribute('data-target') || toggler.getAttribute('data-toggle');
                if (target === null) {
                    target = e.target.nextElementSibling
                }
            }

            if (target !== null) {
                $(target).slideToggle()

                console.log(e.target)
                e.target.classList.toggle('active')
            }
        })
    }
}